import React, { useState } from "react";
import { Box, Chip, IconButton } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { BRAND_COLORS } from "../../utils/brandAssets";
import RosterSlotGrid from "../community/RosterSlotGrid";
import { MARKETING_LINEUP_SLIDES } from "./marketingProductShowcases";

const SWIPE_PX = 40;

const MarketingLineupSlide = ({ slide, onInteract }) => (
  <RosterSlotGrid
    roster={slide.roster}
    sport={slide.sport}
    battingOrder={slide.battingOrder}
    editable
    onSelect={onInteract}
    onClear={onInteract}
    onMove={onInteract}
  />
);

const MarketingLineupPreview = ({ onInteract }) => {
  const [index, setIndex] = useState(0);
  const slide = MARKETING_LINEUP_SLIDES[index];

  const goTo = (next) => {
    setIndex((next + MARKETING_LINEUP_SLIDES.length) % MARKETING_LINEUP_SLIDES.length);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1,
          mb: 3,
        }}
      >
        <IconButton
          aria-label="Previous lineup"
          onClick={() => goTo(index - 1)}
          size="small"
        >
          <ChevronLeftIcon />
        </IconButton>
        <Box
          role="tablist"
          aria-label="Lineup sports"
          sx={{ display: "flex", gap: 1 }}
        >
          {MARKETING_LINEUP_SLIDES.map((item, itemIndex) => {
            const selected = itemIndex === index;
            return (
              <Chip
                key={item.id}
                role="tab"
                aria-selected={selected}
                label={item.label}
                onClick={() => goTo(itemIndex)}
                sx={{
                  fontWeight: 700,
                  bgcolor: selected ? `${BRAND_COLORS.cyan}22` : "action.hover",
                  color: selected ? BRAND_COLORS.cyan : "text.secondary",
                  border: selected
                    ? `1px solid ${BRAND_COLORS.cyan}66`
                    : "1px solid transparent",
                }}
              />
            );
          })}
        </Box>
        <IconButton
          aria-label="Next lineup"
          onClick={() => goTo(index + 1)}
          size="small"
        >
          <ChevronRightIcon />
        </IconButton>
      </Box>
      <Box
        onTouchStart={(event) => {
          event.currentTarget.dataset.swipeX = String(
            event.changedTouches[0].clientX
          );
        }}
        onTouchEnd={(event) => {
          const start = Number(event.currentTarget.dataset.swipeX || 0);
          const dx = event.changedTouches[0].clientX - start;
          if (dx > SWIPE_PX) goTo(index - 1);
          if (dx < -SWIPE_PX) goTo(index + 1);
        }}
      >
        <MarketingLineupSlide slide={slide} onInteract={onInteract} />
      </Box>
    </Box>
  );
};

export default MarketingLineupPreview;
